/**
 * Persona JWT / HMAC failures from game-api (401 + code -401).
 * Do not treat API Gateway 403 {message: Forbidden} as a login expiry —
 * that is an upstream/gateway problem, not an expired persona session.
 */

export function isPersonaAuthError(err) {
  if (!err) return false;
  if (Number(err.code) === -401) return true;
  return err.status === 401;
}

export function personaLoginPath(redirectTo) {
  const target = redirectTo || '/game/rps/play';
  return `/dm/users?redirect=${encodeURIComponent(target)}`;
}
